import { OnInit, Component, Input } from "@angular/core";

@Component({
    selector: 'app-progress-stepper',
    templateUrl: 'progress-stepper.component.html',
    styleUrls: ['progress-stepper.component.scss']
})
export class ProgressStepperComponent implements OnInit {
    ngOnInit(): void {

    }

    @Input('step')
    currentStepNumber: number = 0;
}